import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from '../../organization/hooks/useSelectedOrganization';
import { CreditPackDto, GET_CREDIT_PACKS_QUERY_KEY } from './useListCreditPacks';

export type CreateCreditPackInput = {
  name: string;
  priceInCents: number;
  credits: number;
  sortOrder?: number;
};

export const useCreateCreditPack = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const { selectedOrganization } = useSelectedOrganization();

  return useMutation({
    mutationFn: (input: CreateCreditPackInput) =>
      client.fetchApi<CreditPackDto, CreateCreditPackInput>({
        endpoint: `wallet/admin/credit-packs/${selectedOrganization?.id}`,
        method: 'POST',
        body: input,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_CREDIT_PACKS_QUERY_KEY(selectedOrganization?.id || ''),
      });
    },
  });
};
